export default __webpack_public_path__ + "static/education_b.791bde3fcfdd5a66315d36a1e2e7ce6e.svg";